import { CustomSuspense } from './CustomSuspense';

export const withSuspense = Component => props =>
    (
        <CustomSuspense>
            <Component {...props} />
        </CustomSuspense>
    );
